var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIdsn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 15.492 15.492",
    style: {
      enableBackground: "new 0 0 15.492 15.492"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#090509"
    },
    d: "M9.129,7.38c-0.731,0-1.113,0.657-1.113,1.473c0,0.879,0.435,1.43,1.102,1.43 c0.466,0,0.836-0.318,0.933-0.773c0.03-0.117,0.042-0.232,0.042-0.371V8.461c0-0.086-0.012-0.201-0.021-0.288 C9.976,7.74,9.627,7.38,9.129,7.38z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#090509"
    },
    d: "M14.502,0H0.99C0.443,0,0,0.443,0,0.988v13.513c0,0.547,0.444,0.99,0.989,0.99h13.512 c0.548,0,0.989-0.444,0.989-0.99V0.988C15.491,0.442,15.05,0,14.502,0z M5.367,11.447h-1.62v-7.14h1.62V11.447z M10.317,11.447 l-0.074-0.762H10.22c-0.329,0.582-0.952,0.879-1.62,0.879c-1.229,0-2.214-1.05-2.214-2.66C6.375,7.157,7.467,6.15,8.707,6.15 c0.635,0,1.133,0.223,1.366,0.583h0.021V3.926h1.61V9.9c0,0.584,0.021,1.198,0.043,1.548L10.317,11.447L10.317,11.447z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdsn);
export default __webpack_public_path__ + "static/media/idsn.04c30ec128da7994511e7ac7739ed039.svg";
export { ForwardRef as ReactComponent };